// extracted by mini-css-extract-plugin
module.exports = {"durable-product-details":"styles_durable-product-details__x_vJX","rich-text":"styles_rich-text__K0YRe"};